import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { ProfilingRequestSource } from '../../../configs/profiling/common'
import {
  OnboardingContactServiceMethods,
  OnboardingFail,
  OnboardingResponse,
  OnboardingServices,
} from '../../../configs/service/onboarding'
import { WebSocketStoreKeys } from '../../../configs/service/ws'
import { ContactWorkflowStatus, IContact } from '../model/types'

import { omitUnchangedEmailPixels } from './mapping/omitUnchangedEmailPixels'

type ReplacementContactResponse = {
  contactId: string
  email: string
  entryId375: number
  entryId379: number
  modifiedValues: string
  partnerId: string
  workflowStatus: ContactWorkflowStatus
  error: { message: string; field?: string }[]
}

type ReplacementContactOptions = {
  forceRoles?: boolean
}

export const replacementContact = async (
  { workflowStatus: contactWorkFlowStatus, source: contactSource, ...contact }: Partial<IContact>,
  options?: ReplacementContactOptions
) => {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const workflowStatus = contactWorkFlowStatus || ContactWorkflowStatus.New
  const source = contactSource || ProfilingRequestSource.ClickAndGoPortal
  const replacementEntryId = contact.entryId375 ?? contact.entryId

  return wsClient.call({
    service: OnboardingServices.Contact,
    action: OnboardingContactServiceMethods.Replacement,
    payload: {
      workflowStatus,
      source,
      ...omitUnchangedEmailPixels(contact),
      // Replacement expects the generic entryId field to point to the 375 record.
      entryId: replacementEntryId,
      ...options,
    },
    token: token || undefined,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
  }) as Promise<OnboardingResponse<OnboardingFail, ReplacementContactResponse>>
}
